import { exposedSurveyPending } from 'Services/Misc/survey';

export const isShutdown = state => {
  return (
    state.media.stopped  ||
    state.media.skipped  ||
    state.media.complete
  ) && !exposedSurveyPending(state.configuration, state.measurement);
};


// WEBPACK FOOTER //
// ./src/Services/Misc/ad.js